// extracted by mini-css-extract-plugin
export default {"FavoritesPageContent":"FavoritesPageContent_FavoritesPageContent__JGslh"};